import Axios from "axios";

export default function getCourses(entrance_id,stdId){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'getCourses',
            entrance_id,
            stdId,
        }
    });
    return response;
}